module.exports = __webpack_public_path__ + "img/Intersection 4.50d14854.png";